import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import type { CompanyAnalysisCompetititorItem } from "app/pages/sales-intelligence/modules/company-analysis/types/competitors";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { companyAnalysisQueryKeys } from "./queryKeyFactory";

const useCompetitorsQuery = (options?: {
    enabled?: boolean;
    limit?: number;
    includeSignalsCount?: boolean;
}): UseQueryResult<CompanyAnalysisCompetititorItem[]> => {
    const { enabled = true, limit, includeSignalsCount = false } = options || {};
    const {
        params: { key: domain },
    } = useCurrentStateAndParamsWithFixedDomain();

    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: companyAnalysisQueryKeys.competitors(domain, includeSignalsCount),
        queryFn: async ({ signal }) =>
            await salesApiService.companyAnalysis.fetchCompanyCompetitors(
                {
                    domain,
                    limit,
                    includeSignalsCount,
                },
                {
                    cancellation: signal,
                },
            ),
        select: (data) => data.data,
        enabled: enabled && Boolean(domain),
    });
};

export default useCompetitorsQuery;
